import React, {Dispatch, SetStateAction, useEffect, useRef, useState} from "react";
import {COMMON_MODAL_STYLE} from "../../../helper/StyleHelper";
import {Col, Modal, Row, Table} from "react-bootstrap";
import {IoMdClose} from "react-icons/io";
import Datatables, {getCheckedItems} from "../../component/Datatables";
import axios from "axios";
import {toast} from "react-toastify";
import messageCodeDic from "../../../util/messageCodeDic";
import BMCSelect from "../../../components/common/BMCSelect";
import {getLoginUser} from "../../../helper/SecurityHelper";
import SHSearch from "../../component/BMCSearch";
import BMCInput from "../../../components/common/BMCInput";

interface IProps {
    setModalIsOpen: Dispatch<SetStateAction<boolean>>;
    modalIsOpen: boolean;
    detailData?: any;
    mngrDataList: object[];
    setMngrDataList: Dispatch<SetStateAction<object[]>>;
    isSingleCheck?: boolean
    siteNm?: string
    siteId: number
    cmpnySeq: number

}

const $ = require("jquery")

const SiteMngrSrchModal = (props: IProps) => {
    const [datatable, setDatatable] = useState<any>();
    const searchFormRef = useRef<any>();
    const user = getLoginUser();
    const [isCodeDataLoaded, setIsCodeDataLoaded] = useState<any>(null);
    const [mngrDataList, setMngrDataList] = useState<any>([props.mngrDataList]);
    const [userSeqList, setUserSeqList] = useState<number[]>([]);

    useEffect(() => {
        if(isCodeDataLoaded){
            fn_search();
        }
    }, [isCodeDataLoaded]);

    function fn_closeModal() {
        props.setModalIsOpen(false);
    }

    const fn_search = (e?: any) => {
        e?.preventDefault()
        datatable?.draw()
    }
    const fn_select = () => {
        if (mngrDataList.length == 0) {
            toast.warn('작업자를 선택해 주십시오.');
            return;
        }

        props.setMngrDataList(mngrDataList);
        props.setModalIsOpen(false);
    }

    const fn_onShow = () => {
        let userSeqList:any = []
        props.mngrDataList.map((data: any) => {
            userSeqList.push(data.userSeq);
        })
        setMngrDataList(props.mngrDataList);
        setUserSeqList(userSeqList);
        setIsCodeDataLoaded(false);

    }

    return (
        <div>

            <Modal
                className="bmc-modal sub" size="xl"
                show={props.modalIsOpen}
                onShow={() => {
                    fn_onShow()

                }}
                onHide={fn_closeModal}
            >


                <Modal.Header>
                    <div className="d-flex justify-content-between align-items-center w-100 bmc-font-SD">
                        작업 책임자 추가
                        <IoMdClose className='hover:cursor-pointer' onClick={fn_closeModal}/>
                    </div>
                </Modal.Header>

                <Modal.Body className="px-4">

                    <SHSearch datatable={datatable} formRef={searchFormRef} btnType={'p'}>
                        <BMCInput type={'hidden'} name={'siteId'} value={props.siteId}></BMCInput>
                        <BMCInput type={'hidden'} name={'isSiteMngr'} value={true}></BMCInput>
                        <Row>
                            <Col>
                                <Table className="bmc-font-SP bmc-fs-b2 my-3">
                                    <tbody>
                                    <tr className="border-top align-middle">
                                        <th className="bmc-bg-th" style={{width: '6%'}}>업체명</th>
                                        <td style={{width: '27%'}}>
                                            <BMCSelect initOptionGb={'none'} name={'cmpnySeq'} className={'form-select'}
                                                      selParam={{siteId: props.siteId, cmpnySeq: props.cmpnySeq}}
                                                      disabled={true} codeGb={'siteCmpny'}
                                                      setIsCodeDataLoaded={setIsCodeDataLoaded}
                                            ></BMCSelect>
                                        </td>
                                        <th className="bmc-bg-th" style={{width: '6%'}}>공종</th>
                                        <td style={{width: '27%'}}>
                                            <BMCSelect initOptionGb={'all'} name={'workTypeCd'}  className={'form-select'}
                                                      selParam={{siteId: props.siteId, manageCode: 'M001001'}}
                                                      codeGb={'siteMngCd'}
                                            ></BMCSelect>
                                        </td>
                                        <th className="bmc-bg-th" style={{width: '6%'}}>직종</th>
                                        <td style={{width: '27%'}}>
                                            <BMCSelect initOptionGb={'all'} name={'ocptCd'}  className={'form-select'}
                                                      selParam={{siteId: props.siteId, manageCode: 'M001002'}}
                                                      codeGb={'siteMngCd'}
                                            ></BMCSelect>
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </Col>

                        </Row>
                    </SHSearch>
                    <div className={'ge-result'}>
                        <Datatables
                            dataUrl={'/admin/api/user/retrieveUserDataListWithView'}
                            parameterFormRef={searchFormRef}
                            checkedDataList={userSeqList}
                            pk={'userSeq'}
                            columns={[
                                {data: "userName", title: "성명", textAlign: 'left'},
                                {data: "userPhone", title: "전화번호", textAlign: 'center'},
                                {data: "companyName", title: "소속업체"},
                                {data: "chrgNm", title: "직책"}
                            ]}
                            checked={true}
                            isSingleCheck={props.isSingleCheck}
                            onLoad={(dt: any) => {
                                setDatatable(dt)
                            }}
                            onAllCheckedClick={(datas: any, checked: any)=>{
                                console.log(datas)
                                console.log('checked: ', checked);
                                let cstmUserSeqList = userSeqList;
                                let cstmMngrDataList = mngrDataList;

                                if(checked){
                                    datas.map((data: any) => {
                                        if(cstmUserSeqList.indexOf(data.userSeq) == -1){
                                            cstmUserSeqList.push(data.userSeq);
                                            cstmMngrDataList.push(data);
                                        }
                                    })
                                }else{
                                    datas.map((data: any) => {
                                        const idx = cstmUserSeqList.indexOf(data.userSeq);

                                        if(cstmUserSeqList.indexOf(data.userSeq) > -1){
                                            cstmUserSeqList.splice(idx, 1);
                                            cstmMngrDataList.splice(idx, 1);
                                        }
                                    })
                                }
                            }}
                            onClick={(data) => {
                                console.log('on clicked');
                                let cstmUserSeqList = userSeqList;
                                let cstmMngrDataList = mngrDataList;
                                const idx = cstmUserSeqList.indexOf(data.userSeq);

                                if(data.isChecked){
                                    if(idx == -1){
                                        cstmUserSeqList.push(data.userSeq)
                                        cstmMngrDataList.push(data);

                                    }
                                }else{
                                    if(idx > -1){
                                        cstmUserSeqList.splice(idx, 1);
                                        cstmMngrDataList.splice(idx, 1);
                                    }
                                }
                                // @ts-ignore
                                setUserSeqList([].concat(cstmUserSeqList));
                                setMngrDataList([].concat(cstmMngrDataList));

                            }
                            }
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="py-2">
                    <div className='flex justify-center w-100'>
                        <button
                            className='bmc-btn pill l white me-3'
                            onClick={fn_closeModal}>닫기
                        </button>
                        <button onClick={fn_select}
                                className='bmc-btn pill p'>선택

                        </button>
                    </div>
                </Modal.Footer>


            </Modal>
        </div>
    )
}

export default SiteMngrSrchModal;
